let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("elIMj")).then(() => parcelRequire('bqTTp'));